<template>
  <div w="full" pt="5">
    <div class="mx-auto max-w-300">
      <div mb="6">
        <NuxtLink :to="{ path: `/${locale}`, query: getCommonQuery() }" class="text-xs text-#808080" font="300">
          {{ t('key.home.title.home') }}
        </NuxtLink>
        <span ml="0.5" mr="1" text="#808080">></span>
        <span text="xs #121212" font="300">{{ t('key.rank.breadcrumb.explore') }}</span>
      </div>
      <div font="500" text="2xl #121212" flex="~ items-center" gap="4">
        <span>{{ t('key.attractions.list.things.to.do.in') }}</span>
        <BusinessBCitySelect v-model="cityData" v-model:show="showCitySelect" @change="cityChangeHandler">
          <div class="azgo-haptics-feedback" rounded="12" bg="#F6F6F6" h="10" px="4" flex="~ items-center justify-center" w="fit" @click="showCitySelect = true">
            <div flex="~ items-center justify-between" font="500">
              {{ cityData?.cityName }}
            </div>
            <div ml="1" bg="#121212" rounded="full" w="4" h="4" flex="~ items-center justify-center">
              <NuxtIcon name="my-icon:navback" text="xs white" rotate="-90" />
            </div>
          </div>
        </BusinessBCitySelect>
      </div>
      <van-tabs v-model:active="currentTab" mt="2" class="azgo-tabs--desktop" animated shrink @change="onClickTab">
        <van-tab v-for="tab in rankTypeList" :key="tab.rankType" :name="tab.rankType" :title="tab.rankTypeName"></van-tab>
      </van-tabs>
    </div>
  </div>

  <div w="full" py="4" bg="#F6F6F6" flex="1">
    <div class="mx-auto max-w-300" flex="~ items-stretch">
      <div flex="1">
        <template v-if="!loading && rankList.length">
          <DesktopSearchResultItem v-for="(item, index) in rankList" :key="item.azgoId" :item="item" :rank="index + 1" :type="ENUM_CARD_FROM.RANK_PAGE"></DesktopSearchResultItem>
        </template>
        <template v-if="!loading && searchList.length">
          <DesktopSearchResultItem v-for="(item) in searchList" :key="item.azgoId" :item="item" :type="ENUM_CARD_FROM.RANK_PAGE"></DesktopSearchResultItem>
        </template>
        <div ref="infinitScrollRef" />
        <div v-if="loading || searchLoading" mt="4" text-center>
          <img w="10" :src="LoadingIcon" />
        </div>
        <div
          v-if="!loading && !rankList.length"
          bg="white" rounded="4" p="6" mb="4"
        >
          <MobileSearchEmpty
            :style="{ margin: '50px 0' }"
            :description="t('key.rank.empy.desc')"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { E_CATEGORY_TYPE } from '~/enums'
import { ENUM_CARD_FROM } from '~/enums'
import LoadingIcon from '@/assets/svg/hotel/fade-stagger-circles.svg'
import { getCommonQuery } from '~/utils/common'

const { t } = useI18n()
const { locale } = useLocale()

const {
  rankTypeList,
  currentTab,
  cityData,
  showCitySelect,
  loading,
  rankList,
  searchList,
  searchLoading,
  scrollQuerySearchList,
  tabChange,
  cityChangeHandler,
} = useRank()

const { targetRef: infinitScrollRef } = useInfiniteScroll(loadList)

function loadList() {
  scrollQuerySearchList()
}

function onClickTab(name: E_CATEGORY_TYPE) {
  tabChange(name)
}
</script>

<style>

</style>
